// ثبت اعتبار و تخصیص اعتبارات هزینه‌ای
import React from 'react';
import BudgetTransaction from './BudgetTransaction';

export default function BudgetHazinehCredit({ user, onBack }) {
  return <BudgetTransaction user={user} onBack={onBack} kind={0} />;
}
